/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import Grid from '@mui/material/Grid';
import { Button, MenuItem, OutlinedInput, Select, TextField } from '@mui/material';
import { withStyles } from '@mui/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getServiceManualTypes, navigationButtonStyle } from '../common/common';
import { actionCreators } from '../store/UploadManual';
import './styles.css';
import classNames from 'classnames';

interface Props {
    classes: any,
    next: any,
    back: any
    revision: any
    serviceManualPartNo: any
    displayName: any
    handleManualInformationChange: Function
    handlereleaseDateChange: Function
    releaseDate: any
    documentCategory: any
    documentCategories: any
    UpdateDocumentCategories: Function
}
const styles = () => ({
    input: {
        width: 300,
        backgroundColor: '#fff',
        padding: '10px 14px'
    },
    dateInput: {
        backgroundColor: '#fff',
        padding: '10px 14px'
    },
    selectInput: {
        width: 328,
        height: 40,
        backgroundColor: '#fff'
    },
    disabledOption: {
        color: 'gray'
    },
    navigationButton: navigationButtonStyle
})

class ManualInformation extends React.Component<Props> {
    state = {
    };
    handlereleaseDateChange = (date: Date) => {
        this.props.handlereleaseDateChange(date);
    };
    handleChange = (event: any) => {
        this.props.handleManualInformationChange(event);
    };
    componentDidMount = async () => {
        if (this.props.documentCategories.length === 0) {
            const response = await getServiceManualTypes();
            this.props.UpdateDocumentCategories(response);
        }
    };
    isFilled(value: any) {
        if (value == null || value === undefined || value === '' || value.match(/^ *$/) != null) {
            return false;
        }
        return true;
    }
    render() {
        const { classes, serviceManualPartNo, displayName, documentCategory, revision, releaseDate } = this.props;
        let isDisabled = true;
        if (this.isFilled(displayName)) {
            isDisabled = false;
        }
        return (
            <Grid className="classificationGrid">
                <Grid className="classificationGridTitle">3.Fill the Manual Information </Grid>
                <Grid container className="manualInformationContent">
                    <Grid className="manualInformationLeft">Service Manual P/N</Grid>
                    <Grid><TextField
                        name="serviceManualPartNo"
                        value={serviceManualPartNo}
                        onChange={this.handleChange}
                        variant="outlined"
                        InputProps={{ classes: { input: classes.input } }}
                    /></Grid>
                </Grid>
                <Grid container className="manualInformationContent">
                    <Grid className="manualInformationLeft">Display Name</Grid>
                    <Grid><TextField
                        name="displayName"
                        value={displayName}
                        onChange={this.handleChange}
                        variant="outlined"
                        InputProps={{ classes: { input: classes.input } }}
                        required
                    /></Grid>
                </Grid>
                <Grid container className="manualInformationContent">
                    <Grid className="manualInformationLeft">Document Category</Grid>
                    <Grid>
                        <Select
                            name="documentCategory"
                            value={documentCategory}
                            onChange={this.handleChange}
                            variant="outlined"
                            input={
                                <OutlinedInput
                                    classes={{ root: documentCategory === 0 ? classNames(classes.selectInput, classes.disabledOption) : classes.selectInput }} />
                            }
                        >
                            {this.props.documentCategories.map((x: any) => {
                                return (
                                    <MenuItem className={x.id === 0 && classes.disabledOption} key={x.id} value={x.id}>{x.name}</MenuItem>
                                );
                            })
                            }
                        </Select>
                    </Grid>
                </Grid>
                <Grid container className="manualInformationContent">
                    <Grid className="manualInformationLeft">Revision</Grid>
                    <Grid><TextField
                        name="revision"
                        value={revision}
                        onChange={this.handleChange}
                        variant="outlined"
                        InputProps={{ classes: { input: classes.input } }}
                    /></Grid>        </Grid>
                <Grid container className="manualInformationContent">
                    <Grid className="manualInformationLeft">Release Date</Grid>
                    <Grid>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                format="MMM yyyy"
                                views={["year","month"]}
                                value={releaseDate ? new Date(releaseDate + 'Z') : null}
                                onChange={(date: any) => this.handlereleaseDateChange(date)}
                                disableFuture
                                disabled={!navigator.onLine}
                                slotProps={{
                                    textField: {
                                        variant: 'outlined',
                                        size: "medium",
                                        sx: { width: 328, backgroundColor: "#fff" },
                                        InputProps: { classes: { input: classes.dateInput } }, required: true
                                    }
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>
                </Grid>
                <Grid container justifyContent="flex-end" className="navigatiobuttonGrid manualInformationButton">
                    <Button className={classes.navigationButton} onClick={this.props.back}>Previous</Button>
                    <Button className={classes.navigationButton} onClick={this.props.next} disabled={isDisabled}>Next</Button>
                </Grid>
            </Grid>);
    }
}

const mapStateToProps = (state: any) => ({
    state: state.uploadManual,
    revision: state.uploadManual.revision,
    serviceManualPartNo: state.uploadManual.serviceManualPartNo,
    displayName: state.uploadManual.displayName,
    releaseDate: state.uploadManual.releaseDate,
    documentCategories: state.uploadManual.documentCategories,
    documentCategory: state.uploadManual.documentCategory
});

const mapDispatchtoProps = (dispatch: any) =>
    bindActionCreators(actionCreators, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchtoProps
)(withStyles(styles)(ManualInformation) as any);
